// extracted by mini-css-extract-plugin
module.exports = {"result":"index_result_Ncl2y","plate":"index_plate_3KFy7"};